<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 m-record" id="moreRcd">
                        <div class="row nav-top">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/withdrawal'"></span>
                            </div>
                            <div class="col-8 tfw-5 tf-18">My UPI</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row" id="dtaod">
                            <div class="col-12 mt-4 bdbup">
                                <div class="pl-2 xtl tfcdb">Actual name:</div>
                                <div class="inpbcx up tfcb"><input type="text" v-model="userdetails.actualname"  class="xbox" placeholder="Please Input"
                                        id="upnam"></div>
                            </div>
                            <div class="col-12 mt-4 bdbup">
                                <div class="pl-2 xtl tfcdb">E-Mail Id:</div>
                                <div class="inpbcx up tfcb"><input type="text" v-model="userdetails.email" class="xbox" placeholder="Please Input"
                                        id="email"></div>
                            </div>
                            <div class="col-12 mt-4 bdbup">
                                <div class="pl-2 xtl tfcdb">UPI address:</div>
                                <div class="inpbcx up tfcb"><input type="text" class="xbox" v-model="userdetails.upi" placeholder="Please Input"
                                        id="upad"></div>
                            </div>
                            <div class="col-12 mt-4 bdbup">
                                <div class="pl-2 xtl tfcdb">Confirm UPI address:</div>
                                <div class="inpbcx up tfcb"><input type="text" class="xbox" v-model="userdetails.cupi" placeholder="Please Input"
                                        id="cupad"></div>
                            </div>
                            <div class="col-12 mt-4 bdbup">
                                <div class="pl-2 xtl tfcdb">PAYTM Wallet Number:</div>
                                <div class="inpbcx up tfcb"><input type="text" class="xbox" v-model="userdetails.paytm" placeholder="Please Input"
                                        id="cupad"></div>
                            </div>
                            <div class="col-12">
                                <div class="mt-4 mb-2">
                                    <div class="btn-main act" @click="addbankcard()" >Add</div>
                                </div>
                                <div class="mt-2 btn-con rc" onclick="window.location.href='#/withdrawal'">Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">

                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
</section>
</template>



<script>


import axios from "axios";
export default {
    name: "RechargeRecord",
    data() {
        return {
            countDown: 180,
            otpactive: true,
            userdetails: {
                username: null,
                id: null,
                actualname: null,
                ifsc: null,
                bankname: null,
                account: null,
                state: null,
                city: null,
                upi: null,
                cupi:null,
                address: null,
                mobile: null,
                email: null,
                code: null,
                actualnumber: null,
            },
            bankcard: {

            },
            result: {

            }

        }

    },
    methods: {
        pop(message) {
            alert(message);
        },
       
        addbankcard() {
            if(this.userdetails.upi!=null || this.userdetails.actualname!=null || this.userdetails.email!=null || this.userdetails.cupi!=null){
                if(this.userdetails.upi==this.userdetails.cupi){
                this.userdetails.username = localStorage.getItem('username');
            var data = new FormData();
            data.append("actualname", this.userdetails.actualname),
            data.append("upi", this.userdetails.upi),
            data.append("email", this.userdetails.email),
            data.append("paytm", this.userdetails.paytm),
            axios
                .post(
                    "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=addbankcard&user=" + this.userdetails.username,
                    data
                ).then((res) => {
                    this.result = res.data[0];
                    console.log(this.result.status);
                   console.log(this.userdetails)
                    if(this.result.status=='success'){
                        this.$router.push('/withdrawal');
                    }else{
                        this.pop(this.result.status);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }else{
                this.pop("Upi id doesn't match")
            }
            }else{
                this.pop("Please input Details")
            }
            
            
        },
      

    }
}

</script>